window.NostoPopup = {
  currentProductId: null,
  currentProduct: null,

  open: function (productId, buttonElement) {
    // Check if button has data attribute indicating default-only variant
    // If buttonElement is not provided, try to find it by product ID
    if (!buttonElement) {
      const button = document.querySelector(`.nosto-pdp-card__atc[data-product-id="${productId}"]`);
      if (button) buttonElement = button;
    }

    if (buttonElement && buttonElement.hasAttribute('data-has-only-default-variant')) {
      const variantId = buttonElement.getAttribute('data-variant-id');
      const variantAvailable = buttonElement.getAttribute('data-variant-available') === 'true';

      // If variant is available, add directly to cart
      if (variantAvailable && variantId) {
        this.addToCartDirectly(variantId, 1, buttonElement);
        return;
      }
      // If variant is not available, button should be disabled (handled by CSS)
      // This code path shouldn't be reached if button is properly disabled
      return;
    }

    const dataContainer = document.getElementById(`nosto-data-${productId}`);
    if (!dataContainer) {
      console.error('Nosto Popup: Data container not found for product', productId);
      return;
    }

    const jsonScript = dataContainer.querySelector('.nosto-product-json');
    if (!jsonScript) return;
    let product;
    try {
      product = JSON.parse(jsonScript.textContent);
    } catch (e) {
      console.error('Nosto Popup: Invalid JSON', e);
      return;
    }

    const pickerElement = dataContainer.querySelector('.nosto-variant-picker');
    if (!pickerElement) {
      console.error('Nosto Popup: Variant picker not found for product', productId);
      return;
    }
    const pickerHtml = pickerElement.cloneNode(true);

    const popupInputs = pickerHtml.querySelectorAll('input');
    popupInputs.forEach((input) => {
      const oldId = input.id;
      const newId = oldId + '-popup';
      input.id = newId;
      const label = pickerHtml.querySelector(`label[for="${oldId}"]`);
      if (label) {
        label.setAttribute('for', newId);
      }
    });

    const popup = document.getElementById('nosto-variant-popup');
    const productImage = document.getElementById('nosto-popup-product-image');
    const productTitle = document.getElementById('nosto-popup-product-title');

    this.currentProduct = product;
    if (productTitle) {
      productTitle.textContent = product.title;
      productTitle.href = product.url || '#';
    }

    const firstAvailableVariant =
      product.variants && product.variants.length > 0
        ? product.variants.find((v) => v.available) || product.variants[0]
        : null;

    const variantsContainer = document.getElementById('nosto-popup-variants-container');
    variantsContainer.innerHTML = '';
    variantsContainer.appendChild(pickerHtml);
    document.getElementById('nosto-qty-input').value = 1;
    this.currentProductId = productId;

    this.preselectFirstAvailableVariant(variantsContainer);
    this.bindQtyInput();

    const initialOption =
      variantsContainer.querySelector('select.nosto-variant-master-select option:checked') ||
      (firstAvailableVariant
        ? variantsContainer.querySelector(
            `select.nosto-variant-master-select option[value="${firstAvailableVariant.id}"]`,
          )
        : null);
    if (initialOption) {
      this.updateProductSummary(initialOption, product);
    } else if (productImage && product.featured_image) {
      productImage.src =
        typeof product.featured_image === 'string'
          ? product.featured_image
          : product.featured_image.src;
      productImage.alt = product.title;
    }

    const existingHandler = variantsContainer._nostoVariantHandler;
    if (existingHandler) {
      variantsContainer.removeEventListener('change', existingHandler);
    }

    const variantChangeHandler = (e) => {
      if (e.target.type === 'radio' && e.target.closest('.nosto-variant-picker')) {
        const changedWrapper = e.target.closest('.nosto-variant-wrapper');
        const changedWrapperIndex = changedWrapper
          ? parseInt(changedWrapper.getAttribute('data-option-index')) || 0
          : 0;

        this.updateAvailabilityClasses(variantsContainer, e.target);
        this.autoSelectIfInvalid(variantsContainer, changedWrapperIndex + 1);
        this.onVariantChange();
      }
    };

    variantsContainer._nostoVariantHandler = variantChangeHandler;
    variantsContainer.addEventListener('change', variantChangeHandler);

    const initialChecked = variantsContainer.querySelector('.nosto-variant-fieldset input:checked');
    this.updateAvailabilityClasses(variantsContainer, initialChecked || null);
    this.onVariantChange();

    popup.classList.add('nosto-popup--visible');
    document.body.style.overflow = 'hidden';
  },

  preselectFirstAvailableVariant: function (container) {
    const select = container.querySelector('select.nosto-variant-master-select');
    if (!select) return;

    const firstAvailable = Array.from(select.options).find(
      (opt) => opt.getAttribute('data-available') === 'true',
    );
    if (!firstAvailable) return;

    const options = [
      firstAvailable.getAttribute('data-option1') || '',
      firstAvailable.getAttribute('data-option2') || '',
      firstAvailable.getAttribute('data-option3') || '',
    ];

    const wrappers = Array.from(container.querySelectorAll('.nosto-variant-wrapper')).sort(
      (a, b) =>
        (parseInt(a.getAttribute('data-option-index'), 10) || 0) -
        (parseInt(b.getAttribute('data-option-index'), 10) || 0),
    );

    wrappers.forEach((wrapper, index) => {
      const fieldset = wrapper.querySelector('.nosto-variant-fieldset');
      if (!fieldset) return;
      const optionValue = options[index];
      if (!optionValue) return;

      fieldset.querySelectorAll('input[type="radio"]').forEach((input) => {
        input.checked = input.value === optionValue;
      });
    });

    select.value = firstAvailable.value;
  },

  bindQtyInput: function () {
    const input = document.getElementById('nosto-qty-input');
    if (!input) return;

    const ensureMinQty = () => {
      const val = parseInt(input.value, 10);
      if (!val || val < 1) {
        input.value = 1;
      }
    };

    input.removeEventListener('blur', input._nostoQtyBlur);
    input.removeEventListener('change', input._nostoQtyChange);

    input._nostoQtyBlur = ensureMinQty;
    input._nostoQtyChange = ensureMinQty;
    input.addEventListener('blur', input._nostoQtyBlur);
    input.addEventListener('change', input._nostoQtyChange);
  },

  updateAvailabilityClasses: function (container, lastSelectedOption) {
    const select = container.querySelector('select.nosto-variant-master-select');
    if (!select) return;

    const allVariants = Array.from(select.options);

    // Get all option groups sorted by their index (hierarchical order)
    const wrappers = Array.from(container.querySelectorAll('.nosto-variant-wrapper'));
    const sortedWrappers = wrappers.sort((a, b) => {
      const indexA = parseInt(a.getAttribute('data-option-index')) || 0;
      const indexB = parseInt(b.getAttribute('data-option-index')) || 0;
      return indexA - indexB;
    });

    let firstChecked = sortedWrappers[0]?.querySelector('.nosto-variant-fieldset input:checked');
    if (!firstChecked) {
      this.preselectFirstAvailableVariant(container);
      firstChecked = sortedWrappers[0]?.querySelector('.nosto-variant-fieldset input:checked');
      if (!firstChecked) return;
    }

    const firstOptionValue = firstChecked.value;
    const selectedOptionOneVariants = allVariants.filter((opt) => {
      const o1 = opt.getAttribute('data-option1') || '';
      return o1 === firstOptionValue;
    });

    sortedWrappers.forEach((wrapper, wrapperIndex) => {
      if (wrapperIndex === 0) return;
      if (lastSelectedOption && lastSelectedOption.closest('.nosto-variant-wrapper') === wrapper) {
        return;
      }

      const fieldset = wrapper.querySelector('.nosto-variant-fieldset');
      if (!fieldset) return;

      const inputs = Array.from(fieldset.querySelectorAll('input[type="radio"]'));
      const currentOptionName = `option${wrapperIndex + 1}`;

      // Get the previous option's selected value
      const previousWrapper = sortedWrappers[wrapperIndex - 1];
      const previousFieldset = previousWrapper?.querySelector('.nosto-variant-fieldset');
      const previousChecked = previousFieldset?.querySelector('input:checked');
      if (!previousChecked) return;

      const previousOptionValue = previousChecked.value;

      // Filter variants that match the previous option AND are available
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => {
          const variantOptionValue = variant.getAttribute(`data-option${wrapperIndex}`) || '';
          const isAvailable = variant.getAttribute('data-available') === 'true';
          return variantOptionValue === previousOptionValue && isAvailable;
        })
        .map((variant) => {
          // Get the value for the current option (option2, option3, option4)
          return variant.getAttribute(`data-${currentOptionName}`) || '';
        })
        .filter((val) => val !== ''); // Remove empty values

      // Update each input's availability
      inputs.forEach((input) => {
        const value = input.value;
        const inputId = input.getAttribute('id');
        const label = fieldset.querySelector(`label[for="${inputId}"]`);

        let variantValueExists = false;
        selectedOptionOneVariants.forEach((variant) => {
          const o1 = variant.getAttribute('data-option1') || '';
          const o2 = variant.getAttribute('data-option2') || '';
          const o3 = variant.getAttribute('data-option3') || '';
          if (o1 === value || o2 === value || o3 === value) {
            variantValueExists = true;
          }
        });

        const isAvailable = availableOptionInputsValue.includes(value);

        if (isAvailable && variantValueExists) {
          if (label) label.classList.remove('is-unavailable');
          input.removeAttribute('disabled');
          input.classList.remove('is-unavailable');
        } else {
          if (label) label.classList.add('is-unavailable');
          input.setAttribute('disabled', 'disabled');
          input.classList.add('is-unavailable');
        }
      });
    });
  },

  autoSelectIfInvalid: function (container, changedWrapperIndex) {
    const wrappers = Array.from(container.querySelectorAll('.nosto-variant-wrapper'));
    const sortedWrappers = wrappers.sort((a, b) => {
      const indexA = parseInt(a.getAttribute('data-option-index')) || 0;
      const indexB = parseInt(b.getAttribute('data-option-index')) || 0;
      return indexA - indexB;
    });

    for (let i = changedWrapperIndex; i < sortedWrappers.length; i++) {
      const wrapper = sortedWrappers[i];
      const fieldset = wrapper.querySelector('.nosto-variant-fieldset');
      if (!fieldset) continue;

      const checkedInput = fieldset.querySelector('input:checked');

      if (checkedInput) {
        const isUnavailable =
          checkedInput.classList.contains('is-unavailable') ||
          checkedInput.hasAttribute('disabled');

        if (isUnavailable) {
          const allInputs = Array.from(fieldset.querySelectorAll('input[type="radio"]'));
          let foundAvailable = false;

          for (const input of allInputs) {
            const inputIsUnavailable =
              input.classList.contains('is-unavailable') || input.hasAttribute('disabled');
            if (!inputIsUnavailable) {
              input.checked = true;
              foundAvailable = true;
              input.dispatchEvent(new Event('change', { bubbles: true }));
              return;
            }
          }

          if (!foundAvailable) {
            checkedInput.checked = false;
          }
        }
      } else {
        const allInputs = Array.from(fieldset.querySelectorAll('input[type="radio"]'));
        for (const input of allInputs) {
          const inputIsUnavailable =
            input.classList.contains('is-unavailable') || input.hasAttribute('disabled');
          if (!inputIsUnavailable) {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
            return;
          }
        }
      }
    }
  },

  close: function () {
    const popup = document.getElementById('nosto-variant-popup');
    popup.classList.remove('nosto-popup--visible');
    document.body.style.overflow = '';
    this.currentProduct = null;

    const variantsContainer = document.getElementById('nosto-popup-variants-container');
    if (variantsContainer && variantsContainer._nostoVariantHandler) {
      variantsContainer.removeEventListener('change', variantsContainer._nostoVariantHandler);
      variantsContainer._nostoVariantHandler = null;
    }
  },

  adjustQty: function (delta) {
    const input = document.getElementById('nosto-qty-input');
    if (!input) return;

    let val = parseInt(input.value, 10) || 1;
    val += delta;
    if (val < 1) val = 1;
    input.value = val;
  },

  toggleOptions: function (btn) {
    const fieldset = btn.closest('.nosto-variant-fieldset');
    const hiddenInputs = fieldset.querySelectorAll('[data-hidden-option="true"]');
    const isExpanded = btn.classList.contains('nosto-expanded');

    const showMoreCount = btn.querySelector('.nosto-show-more-count');
    const showLessText = btn.querySelector('.nosto-show-less-text');

    if (isExpanded) {
      // Collapse
      hiddenInputs.forEach((el) => (el.style.display = 'none'));
      btn.classList.remove('nosto-expanded');

      if (showMoreCount) showMoreCount.style.display = 'inline';
      if (showLessText) showLessText.style.display = 'none';
    } else {
      // Expand
      hiddenInputs.forEach((el) => (el.style.display = 'block'));
      btn.classList.add('nosto-expanded');

      if (showMoreCount) showMoreCount.style.display = 'none';
      if (showLessText) showLessText.style.display = 'inline';
    }
  },

  updateProductSummary: function (matchedOption, product) {
    const productImage = document.getElementById('nosto-popup-product-image');
    const productPrice = document.getElementById('nosto-popup-product-price');
    if (!matchedOption) return;

    const price = parseInt(matchedOption.getAttribute('data-price'), 10) || 0;
    const compareAt = parseInt(matchedOption.getAttribute('data-compare-at-price'), 10) || 0;
    const unitPrice = matchedOption.getAttribute('data-unit-price') || '';
    let imageUrl = matchedOption.getAttribute('data-featured-image') || '';

    if (!imageUrl && product && product.variants) {
      const variantId = matchedOption.value;
      const variantData = product.variants.find((v) => String(v.id) === String(variantId));
      if (variantData && variantData.featured_image) {
        imageUrl =
          typeof variantData.featured_image === 'string'
            ? variantData.featured_image
            : variantData.featured_image.src;
      }
    }

    if (!imageUrl && product && product.featured_image) {
      imageUrl =
        typeof product.featured_image === 'string'
          ? product.featured_image
          : product.featured_image.src;
    }

    if (productImage && imageUrl) {
      productImage.src = imageUrl;
      productImage.alt = product ? product.title : '';
    }

    if (productPrice) {
      productPrice.innerHTML = this.renderPriceHTML(price, compareAt, unitPrice);
    }
  },

  renderPriceHTML: function (priceCents, compareAtCents, unitPriceText) {
    const isOnSale = compareAtCents > priceCents;
    const unitPrice = unitPriceText
      ? `<span class="product__unit-price">${unitPriceText}</span>`
      : '';
    const unitAttr = unitPriceText ? ' data-unit-price' : '';

    if (!isOnSale) {
      return `<div class="block-price__container nosto-price"${unitAttr}>
        <div class="block-price__regular product__price">
          ${this.formatMoney(priceCents)}
          ${unitPrice}
        </div>
      </div>`;
    }

    const savedPct = Math.round(((compareAtCents - priceCents) * 100.0) / compareAtCents);
    const savings = `<span class="block-price__save product__price-savings on-sale">–${savedPct} %</span>`;

    return `<div class="block-price__container nosto-price" data-on-sale${unitAttr}>
      <div class="block-price__sale product__price ts-lg-block-price__regular">
        <span class="product__price">${this.formatMoney(priceCents)}</span>
        ${unitPrice}
      </div>
      <div class="block-price__sale product__price ts-lg-block-price__sale">
        <span>Ursprünglich:</span>
        <span><s>${this.formatMoney(compareAtCents)}</s></span>
        ${savings}
      </div>
    </div>`;
  },

  onVariantChange: function () {
    const container = document.getElementById('nosto-popup-variants-container');
    const options = {};

    // Gather selected options
    const checkedInputs = container.querySelectorAll('input:checked');
    checkedInputs.forEach((input) => {
      const index = input.getAttribute('data-index');
      options[index] = input.value;
    });

    // Find matching variant
    const select = container.querySelector('select.nosto-variant-master-select');
    const selectOptions = Array.from(select.options);

    const matchedOption = selectOptions.find((opt) => {
      const o1 = opt.getAttribute('data-option1');
      const o2 = opt.getAttribute('data-option2');
      const o3 = opt.getAttribute('data-option3');

      let match = true;
      if (o1 && options['option1'] !== o1) match = false;
      if (o2 && options['option2'] !== o2) match = false;
      if (o3 && options['option3'] !== o3) match = false;

      return match;
    });

    const addToCartBtn = document.getElementById('nosto-add-to-cart-btn');
    const btnText = addToCartBtn && addToCartBtn.querySelector('.nosto-btn-text');

    if (matchedOption && addToCartBtn && btnText) {
      select.value = matchedOption.value;
      const price = parseInt(matchedOption.getAttribute('data-price'), 10) || 0;
      const available = matchedOption.getAttribute('data-available') === 'true';

      this.currentVariantPriceCents = price;
      this.updateProductSummary(matchedOption, this.currentProduct);

      if (available) {
        addToCartBtn.disabled = false;
        btnText.textContent = 'In den Warenkorb';
      } else {
        addToCartBtn.disabled = true;
        btnText.textContent = 'Ausverkauft';
      }
    } else {
      select.value = '';
      this.currentVariantPriceCents = 0;
      if (addToCartBtn) addToCartBtn.disabled = true;
      if (btnText) btnText.textContent = 'Nicht verfügbar';
      const productPrice = document.getElementById('nosto-popup-product-price');
      if (productPrice) productPrice.innerHTML = '';
    }
  },

  formatMoney: function (cents) {
    return (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
  },

  normalizeCartAddResponse: function (data) {
    if (!data || data.status >= 400 || data.message) return [];

    if (Array.isArray(data.items) && data.items.length) {
      return data.items;
    }

    if (data.variant_id != null || data.id != null) {
      return [data];
    }

    return [];
  },

  triggerCartAddedFeedback: function (data, quantity) {
    const products = this.normalizeCartAddResponse(data);
    if (!products.length) return;

    const qty = quantity || products[0].quantity || 1;

    window._nostoCartFeedbackQty = qty;
    document.dispatchEvent(
      new CustomEvent('ajaxProduct:added', {
        detail: { product: products[0], products: products, quantity: qty },
      }),
    );
    window._nostoCartFeedbackQty = null;
  },

  addToCartDirectly: function (variantId, quantity, buttonElement) {
    if (buttonElement) {
      buttonElement.classList.add('nosto-pdp-card__atc--loading');
    }

    const formData = {
      items: [
        {
          id: variantId,
          quantity: quantity || 1,
        },
      ],
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        if (!response.ok) {
          return response.json().then((err) => {
            throw err;
          });
        }
        return response.json();
      })
      .then((data) => {
        if (buttonElement) {
          buttonElement.classList.remove('nosto-pdp-card__atc--loading');
        }

        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(new CustomEvent('cart:add'));
        document.dispatchEvent(new CustomEvent('cart:refresh'));

        this.triggerCartAddedFeedback(data, quantity || 1);
      })
      .catch((error) => {
        console.error('Error:', error);
        if (buttonElement) {
          buttonElement.classList.remove('nosto-pdp-card__atc--loading');
        }
        alert('Fehler beim Hinzufügen zum Warenkorb.');
      });
  },

  addToCart: function () {
    const container = document.getElementById('nosto-popup-variants-container');
    const select = container.querySelector('select.nosto-variant-master-select');
    const variantId = select.value;

    const qty = parseInt(document.getElementById('nosto-qty-input').value, 10) || 1;
    const btn = document.getElementById('nosto-add-to-cart-btn');

    if (!variantId) {
      alert('Bitte wählen Sie eine Variante aus.');
      return;
    }

    btn.disabled = true;
    const originalText = btn.querySelector('.nosto-btn-text').textContent;
    btn.querySelector('.nosto-btn-text').textContent = 'Wird hinzugefügt...';

    const formData = {
      items: [
        {
          id: variantId,
          quantity: qty,
        },
      ],
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        if (!response.ok) {
          return response.json().then((err) => {
            throw err;
          });
        }
        return response.json();
      })
      .then((data) => {
        this.close();

        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(new CustomEvent('cart:add'));
        document.dispatchEvent(new CustomEvent('cart:refresh'));

        this.triggerCartAddedFeedback(data, qty);
      })
      .catch((error) => {
        console.error('Error:', error);
        alert('Fehler beim Hinzufügen zum Warenkorb.');
      })
      .finally(() => {
        btn.disabled = false;
        btn.querySelector('.nosto-btn-text').textContent = originalText;
      });
  },
};

(function patchCartFeedbackForNosto() {
  function applyPatch() {
    if (typeof display_cart_feedback !== 'function' || display_cart_feedback.__nostoPatched) {
      return;
    }

    const original = display_cart_feedback;

    window.display_cart_feedback = function (items) {
      const nostoQty = window._nostoCartFeedbackQty;
      let bridge;

      if (nostoQty) {
        bridge = document.getElementById('nosto-qty-bridge');
        if (!bridge) {
          bridge = document.createElement('quantity-selector');
          bridge.id = 'nosto-qty-bridge';
          bridge.hidden = true;
          const input = document.createElement('input');
          input.name = 'quantity';
          bridge.appendChild(input);
          // Prepend (not append) so this is always the first
          // `quantity-selector [name="quantity"]` in document order —
          // display_cart_feedback's selector is unscoped and otherwise
          // picks up an unrelated quantity-selector already on the page.
          document.body.insertBefore(bridge, document.body.firstChild);
        }
        bridge.querySelector('[name="quantity"]').value = nostoQty;
      }

      original(items);

      if (bridge) {
        bridge.remove();
      }

      window._nostoCartFeedbackQty = null;
    };

    display_cart_feedback.__nostoPatched = true;
  }

  applyPatch();
  document.addEventListener('DOMContentLoaded', applyPatch);
})();
